import { AbstractControl, ValidationErrors, ValidatorFn } from "@angular/forms";

export function hasUppercaseValidator (): ValidatorFn {
  return (control: AbstractControl): ValidationErrors | null => {
    const str: string = control.value;
    for (let i = 0; i < str.length; i++) {
      const char = str[i];
      if (
        char.toLowerCase() !== char.toUpperCase() &&
        char === char.toUpperCase()
      ) {
        return null;
      }
    }

    return { "hasUppercase": { "value": str } };
  };
}
